import ThankYouSuccess from '@/pages/thank-you/ThankYouSuccess.vue';
import ThankYouFail from '@/pages/thank-you/ThankYouFail.vue';
import ThankYouSaveForLater from '@/pages/thank-you/ThankYouSaveForLater.vue';
import NotAvailablePage from '@/pages/NotAvailablePage.vue';
import ESignatureFail from '@/pages/thank-you/ESignatureFail.vue';
import ESignatureIdentityFail from '@/pages/thank-you/ESignatureIdentityFail.vue';
import ESignatureSuccess from '@/pages/thank-you/ESignatureSuccess.vue';
import NotFoundPage from '@/pages/NotFoundPage.vue';
import SmsThankYouPage from '@/pages/thank-you/SmsThankYouPage.vue';

export default [
  {
    name: 'ThankYouSuccess',
    path: '/thank-you-success',
    component: ThankYouSuccess,
    meta: {
      pathEN: '/thank-you-success',
      pathUA: '/thank-you-success',
      pathRU: '/thank-you-success',
      step: 22,
      routeStepType: 'COMMON',
    },
  },
  {
    name: 'ThankYouFail',
    path: '/thank-you-fail',
    component: ThankYouFail,
    meta: {
      pathEN: '/thank-you-fail',
      pathUA: '/thank-you-fail',
      pathRU: '/thank-you-fail',
      step: 22,
      routeStepType: 'COMMON',
    },
  },
  {
    name: 'ThankYouSaveForLater',
    path: '/thank-you-save-for-later',
    component: ThankYouSaveForLater,
    meta: {
      pathEN: '/thank-you-save-for-later',
      pathUA: '/thank-you-save-for-later',
      pathRU: '/thank-you-save-for-later',
      step: 22,
      routeStepType: 'COMMON',
    },
  },
  {
    name: 'NotAvailablePage',
    path: '/error-page',
    component: NotAvailablePage,
    meta: {
      pathEN: '/error-page',
      pathUA: '/error-page',
      pathRU: '/error-page',
      step: 22,
      routeStepType: 'COMMON',
    },
  },
  {
    name: 'NotFoundPage',
    path: '/not-found-page',
    component: NotFoundPage,
    meta: {
      pathEN: '/not-found-page',
      pathUA: '/not-found-page',
      pathRU: '/not-found-page',
      step: 22,
      routeStepType: 'COMMON',
    },
  },
  {
    name: 'SmsThankYouPage',
    path: '/thank-you-success',
    component: SmsThankYouPage,
    meta: {
      pathEN: '/thank-you-success',
      pathUA: '/thank-you-success',
      pathRU: '/thank-you-success',
      step: 22,
      routeStepType: 'COMMON',
    },
  },
  {
    name: 'ESignatureIdentityFail',
    path: '/e-signature-identity-fail',
    component: ESignatureIdentityFail,
    meta: {
      pathEN: '/e-signature-identity-fail',
      pathUA: '/e-signature-identity-fail',
      pathRU: '/e-signature-identity-fail',
      step: 22,
      routeStepType: 'COMMON',
    },
  },
  {
    name: 'ESignatureFail',
    path: '/e-signature-fail',
    component: ESignatureFail,
    meta: {
      pathEN: '/e-signature-fail',
      pathUA: '/e-signature-fail',
      pathRU: '/e-signature-fail',
      step: 22,
      routeStepType: 'COMMON',
    },
  },
  {
    name: 'ESignatureSuccess',
    path: '/e-signature-success',
    component: ESignatureSuccess,
    meta: {
      pathEN: '/e-signature-success',
      pathUA: '/e-signature-success',
      pathRU: '/e-signature-success',
      step: 22,
      routeStepType: 'COMMON',
    },
  },
];
